/**
 * EIP-3085: Public Chainlist RPC endpoints for wallet_addEthereumChain.
 * Use well-known public nodes, NOT the platform's own RPC.
 */
export const CHAIN_ADD_CONFIGS: Record<
  number,
  {
    chainName: string;
    nativeCurrency: { name: string; symbol: string; decimals: number };
    rpcUrls: string[];
    blockExplorerUrls: string[];
  }
> = {
  56: {
    chainName: 'BNB Smart Chain',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: ['https://bsc-dataseed.binance.org', 'https://bsc.publicnode.com'],
    blockExplorerUrls: ['https://bscscan.com'],
  },
  97: {
    chainName: 'BNB Smart Chain Testnet',
    nativeCurrency: { name: 'tBNB', symbol: 'tBNB', decimals: 18 },
    rpcUrls: [
      'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
      'https://bsc-testnet.publicnode.com',
    ],
    blockExplorerUrls: ['https://testnet.bscscan.com'],
  },
  11155111: {
    chainName: 'Sepolia Testnet',
    nativeCurrency: { name: 'SepoliaETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: [
      'https://rpc.sepolia.org',
      'https://sepolia.gateway.tenderly.co',
    ],
    blockExplorerUrls: ['https://sepolia.etherscan.io'],
  },
};

/** EIP-6963: RDNS -> WalletType mapping */
export const RDNS_TO_WALLET_TYPE: Record<string, string> = {
  'io.metamask': 'metamask',
  'com.trustwallet.app': 'trustwallet',
  'com.okex.wallet': 'okxwallet',
};

export const WALLET_STORAGE_KEY = 'custos_wallet_type';
